import React from "react";
import { Link, useNavigate } from "react-router-dom";
// import ProfileIcon from "../../assets/svg/profile.svg";
// import LockIcon from "../../assets/svg/lock.svg";
// import AuthIcon from "../../assets/svg/GA.svg";
// import IpIcon from "../../assets/svg/IP.svg";
// import MobilePrincipleLogo from "../../assets/svg/Principle.svg";
// import MobileTransferLogo from "../../assets/svg/Transfer-mobile.svg";
import "./Drawer.css";

const MobileProfileDrawer = () => {
  const navigate = useNavigate();
  const goToProfilePage = () => {
    navigate("/profile");
  };

  const goToTwofaPage = () => {
    navigate("/twofaguide");
  };

  const goToChangePin = () => {
    navigate("/change-password");
  };

  const goToIpPage = () => {
    navigate("/add-ip");
  };

  const goToPrinciplePage = () => {
    navigate("/principle");
  };

  const goToTransferPage = () => {
    navigate("/transfer-history");
  };

  return (
    <>
      <div className="profile-drawer">
        <div className="container">
          <div className="profile-content-wrap">
            <div
              className="profile-icon"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={goToProfilePage}
            >
              {/* <img src={ProfileIcon} alt="icon" /> */}
              <p> My Profile</p>
            </div>

            <div
              className="profile-icon"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={goToChangePin}
            >
              {/* <img src={LockIcon} alt="icon" /> */}
              <p> Password Settings</p>
            </div>
            <div
              className="profile-icon"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={goToTwofaPage}
            >
              {/* <img src={AuthIcon} alt="icon" /> */}
              <p>Two-Factor</p>
            </div>
            <div
              className="profile-icon"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={goToIpPage}
            >
              {/* <img src={IpIcon} alt="icon" /> */}
              <p> IP Whitelist</p>
            </div>

            <div
              className="profile-icon"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={goToPrinciplePage}
            >
              {/* <img src={MobilePrincipleLogo} alt="icon" /> */}
              <p> Principle Orders</p>
            </div>

            <div
              className="profile-icon"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={goToTransferPage}
            >
              {/* <img src={MobileTransferLogo} alt="icon" /> */}
              <p> Transfer Order</p>
            </div>
          </div>

          <div className="profile-drawer-bottom">
            <button> Logout </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileProfileDrawer;
